module.exports = __webpack_public_path__ + "img/goaf.129e65ae.jpg";